import { GET_REPORT_REVENUE } from "./type";

export const initialState = {
  reportRevenues: [],
};

export function reportManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_REPORT_REVENUE:
      return {
        ...state,
        reportRevenues: action.payload.data
      };
    default:
      return state;
  }
}
